module.exports = __webpack_public_path__ + "img/banner_text_zh.51b77fec.png";